import React from 'react';

/**
 * Reusable feature card on the print template (Warranty / Consommation /
 * Financing). Renders an icon + label in the top corner and a single
 * value in the lower-right corner.
 *
 * The compact variant is used by the new-model template — smaller value
 * font, rounded square card.
 *
 * @param {object} props
 * @param {React.ComponentType} props.icon — @phosphor-icons/react icon component.
 * @param {string} props.label — short label (e.g. "Warranty").
 * @param {string} props.value — value (e.g. "2 years"). For new-model
 *   templates the caller should pass the value already passed through
 *   `noBreakUnits()`.
 * @param {boolean} [props.compact=false] — use the compact (new-model) variant.
 */
const FeatureCard = ({ icon: Icon, label, value, compact = false }) => {
  const className = compact
    ? 'print-template__card print-template__card--compact'
    : 'print-template__card';

  return (
    <div className={className}>
      <div className="print-template__card-top">
        <Icon className="print-template__card-icon" weight="light" />
        <span className="print-template__card-label">{label}</span>
      </div>
      <span className="print-template__card-value">{value}</span>
    </div>
  );
};

export default React.memo(FeatureCard);
